import { LoadManager } from 'managers/LoadManager'

import { signal } from '../../services/SignalsService'

const name = 'LOAD'

async function execute() {
  signal.dispatch('GENERATE-INTRO:BLUR:TEXTURE')
  return LoadManager.main()
}

export function getLoadAction() {
  return {
    name,
    execute,
  }
}
